// VerificationContext.js
import React, { createContext, useContext, useState } from 'react';

const VerificationContext = createContext();

export const VerificationProvider = ({ children }) => {
    const [isVerificationPending, setIsVerificationPending] = useState(false);

    return (
        <VerificationContext.Provider value={{ isVerificationPending, setIsVerificationPending }}>
            {children}
        </VerificationContext.Provider>
    );
};

export const useVerification = () => useContext(VerificationContext);
